













































































































import Vue from 'vue';
import {
  FullscreenWrapper,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';

import { required } from 'vuelidate/lib/validators';

import { api, MEMBER_API_SUB_URLS, V2 } from '@/api';

import {
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
} from '@/mixins';
import { ExtendMixins } from '@/services';
import { UserModel } from '@/@types/member';

interface Data {
  formValid: boolean;
  question1: string;
  question2: string;
  question3: string;
  formModel: {
    question1Answer: string;
    question2Answer: string;
    question3Answer: string;
  };
  showSubmitSuccessMessage: boolean;
  successMessage: string;
  showSubmitErrorMessage: boolean;
  errorMessage: string;
  isLoading: boolean;
  answerMap: {
    answer1: {
      0: string;
      1: string;
      2: string;
    },
    answer2: {
      0: string;
      1: string;
    },
  };
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  FormValidation,
  TriggerRefreshError,
).extend({
  name: 'Questions',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      formValid: false,
      question1: this.$options.filters.t('segmentation-question-1'),
      question2: this.$options.filters.t('segmentation-question-2'),
      question3: this.$options.filters.t('segmentation-question-3'),
      formModel: {
        question1Answer: '',
        question2Answer: '',
        question3Answer: '',
      },
      showSubmitSuccessMessage: false,
      successMessage: this.params.successMessage,
      showSubmitErrorMessage: false,
      errorMessage: this.params.errorMessage,
      isLoading: false,
      answerMap: {
        answer1: {
          0: 'Yes',
          1: 'No',
          2: 'I Don\'t Know',
        },
        answer2: {
          0: 'Spender',
          1: 'Saver',
        },
      },
    };
  },
  beforeMount() {
    this.constructShowErrorModel('formModel');
  },
  validations: {
    formModel: {
      question1Answer: {
        required,
      },
      question2Answer: {
        required,
      },
      question3Answer: {},
    },
  },
  computed: {
    user(): UserModel {
      return this.$store.getters.user;
    },
  },
  methods: {
    proceedToApp(): void {
      this.closeFullscreenWrapper();
      this.$router.push({
        name: 'accounts',
      });
    },
    goBack(): void {
      this.showSubmitErrorMessage = false;
    },
    submitQuestions(): void {
      this.isLoading = true;
      api
        .post(
          `${MEMBER_API_SUB_URLS.members}/${this.user.memberId}/segmentation-questions${V2}`,
          [
            {
              segmentationNumber: 1,
              segmentationQuestion: this.question1,
              segmentationAnswer: this.answerMap.answer1[
                this.formModel.question1Answer
              ],
            },
            {
              segmentationNumber: 2,
              segmentationQuestion: this.question2,
              segmentationAnswer: this.answerMap.answer2[
                this.formModel.question2Answer
              ],
            },
            {
              segmentationNumber: 3,
              segmentationQuestion: this.question3,
              segmentationAnswer: this.formModel.question3Answer.toString(),
            },
          ],
        )
        .then(() => {
          this.refreshTaskList();
        })
        .catch(() => {
          this.isLoading = false;
          this.showSubmitErrorMessage = true;
        });
    },
    refreshTaskList(): void {
      this.$store
        .dispatch('getMemberTaskList')
        .then(() => {
          this.isLoading = false;
          this.showSubmitSuccessMessage = true;
        })
        .catch(() => {
          this.triggerRefreshError({
            message: [
              'segmentation-questions_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
